import Environment from "./environment";

export const parsePhotoUrl = (url: string) => {
    if (url.startsWith('/static/')) {
        return Environment.VITE_API_URL + url;
    }
    return url;
}